const Constants = {
  SUCCESS: 'ALERT_SUCCESS',
  ERROR: 'ALERT_ERROR',
  CLEAR: 'ALERT_CLEAR',

  REGISTER_REQUEST: 'USERS_REGISTER_REQUEST',
  REGISTER_SUCCESS: 'USERS_REGISTER_SUCCESS',
  REGISTER_FAILURE: 'USERS_REGISTER_FAILURE',

  LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
  LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
  LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',

  LOGOUT: 'USERS_LOGOUT',

  GETALLHOUSES_REQUEST: 'USERS_GETALLHOUSES_REQUEST',
  GETALLHOUSES_SUCCESS: 'USERS_GETALLHOUSES_SUCCESS',
  GETALLHOUSES_FAILURE: 'USERS_GETALLHOUSES_FAILURE',

  GETALLFAVORITES_REQUEST: 'USER_GETALLFAVORITES_REQUEST',
  GETALLFAVORITES_SUCCESS: 'USER_GETALLFAVORITES_SUCCESS',
  GETALLFAVORITES_FAILURE: 'USER_GETALLFAVORITES_FAILURE',

  ADDTOFAVORITES_REQUEST: 'USER_ADDTOFAVORITES_REQUEST',
  ADDTOFAVORITES_SUCCESS: 'USER_ADDTOFAVORITES_SUCCESS',
  ADDTOFAVORITES_FAILURE: 'USER_ADDTOFAVORITES_FAILURE',

  REMOVEFAVORITE_REQUEST: 'USER_REMOVEFAVORITE_REQUEST',
  REMOVEFAVORITE_SUCCESS: 'USER_REMOVEFAVORITE_SUCCESS',
  REMOVEFAVORITE_FAILURE: 'USER_REMOVEFAVORITE_FAILURE',

};

export default Constants;
